import moment from "moment";

import { shopId, scheduleEventId } from "../config/const";
import { callFetch, idTokenHeader, tokenHeader } from "./utils";

const EndPoint = {
  BookActivity: (lineId) =>
    `/linewebhook/activity/shop/${shopId}/${lineId}/book`,
  SignupActivity: (lineId, appointmentId) =>
    `/linewebhook/activity/shop/${shopId}/${lineId}/book/${appointmentId}/signup`,
  GetCustomerActivityInfo: (lineId) =>
    `/linewebhook/activity/shop/${shopId}/${lineId}/${scheduleEventId}/appointments`,
  GetActivity: () => `/linewebhook/activity/shop/${shopId}/${scheduleEventId}`,
  GetActivityTime: (startdate, enddate) =>
    `/linewebhook/activity/shop/${shopId}/${scheduleEventId}/schedule?startdate=${startdate}&enddate=${enddate}`,
  CancelActivity: (lineId, appointmentId) =>
    `/linewebhook/activity/shop/${shopId}/${lineId}/book/${appointmentId}`,
};

// activity

export function bookActivity(lineId, idToken, data) {
  const uri = EndPoint.BookActivity(lineId, idToken);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(data),
  };

  return callFetch(uri, settings);
}

export function signupActivity(lineId, appointmentId, idToken, code = "") {
  const uri = EndPoint.SignupActivity(lineId, appointmentId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ code }),
  };

  return callFetch(uri, settings);
}

export function getCustomerActivityInfo(lineId, idToken) {
  const uri = EndPoint.GetCustomerActivityInfo(lineId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getActivity(idToken) {
  const uri = EndPoint.GetActivity();
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getActivityTime(idToken, startdate, enddate) {
  const uri = EndPoint.GetActivityTime(
    moment(startdate).format("YYYY-MM-DD"),
    moment(enddate).format("YYYY-MM-DD")
  );
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function cancelActivity(idToken, lineId, appointmentId) {
  const uri = EndPoint.CancelActivity(lineId, appointmentId);
  let settings = {
    method: "PATCH",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ status: "CANCEL" }),
  };

  return callFetch(uri, settings);
}
